export default __webpack_public_path__ + "media/environment_friendly_3.2325e556.png";